import * as React from 'react';
import { type Position, Tooltip as ReactTippyTooltip, type Theme } from 'react-tippy';
import classNames from 'classnames';

const DEFAULT_TITLE = ' ';

type Props = {
  body?: string | React.ReactElement<any>;
  hide?: boolean;
  upperRight?: boolean;
  className?: string;
  infoIconClassName?: string;
  children?: React.ReactNode;
  title?: string;
  html?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  position?: string | Position;
  interactive?: boolean;
};

const Tooltip = (props: Props) => {
  const { infoIconClassName, upperRight, body, title, hide, children } = props;

  const getNecessaryProperties = () => {
    if (typeof title === 'string') {
      return {
        title: '',
        html: <span>{title}</span>,
      };
    }

    if (typeof body === 'string') {
      return {
        html: <span>{body}</span>,
      };
    }

    if (body) {
      return {
        html: body,
      };
    }

    return {
      title: DEFAULT_TITLE,
    };
  };

  const defaults = {
    theme: 'light' as Theme,
    arrow: true,
    interactive: true,
  };
  const properties = {
    ...defaults,
    ...props,
    ...getNecessaryProperties(),
    popperOptions: {
      modifiers: {
        preventOverflow: {
          enabled: false,
        },
      },
    },
    className: classNames(props.className, {
      'tooltip-info-icon-container': !children,
      'upper-right-corner': upperRight,
    }),
  };

  const renderInfoIcon = () => {
    return (
      <i
        className={classNames('material-icons tooltip-icon', infoIconClassName, {
          'h_va-u': upperRight,
        })}
      >
        info_outline
      </i>
    );
  };

  if (hide) {
    return null;
  }

  return <ReactTippyTooltip {...(properties as any)}>{children || renderInfoIcon()}</ReactTippyTooltip>;
};

export default React.memo(Tooltip);
